import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import * as permissionKind from '../../../../shared/permissions';
import { useGetEventQuery } from '../../../api/queries/getEvent';
import LoadingElement from '../../../components/LoadingElement';
import NotFoundResult from '../../../components/results/NotFoundResult';
import hasPermissions from '../../../utilities/hasPermissions';
import EventDetailsInnerPage from './EventDetailsInnerPage';

export type EventDetailsPageProps = {
    disabled?: boolean;
};

const EventDetailsPage = ({ disabled = false }: EventDetailsPageProps) => {
    const { eventId } = useParams<{ eventId: string }>();

    const { data, loading } = useGetEventQuery({
        fetchPolicy: 'network-only',
        variables: { id: eventId },
    });

    const event = data?.event;
    const hasUpdatePermission = useMemo(
        () => hasPermissions(event?.permissions, [permissionKind.updateEvent]),
        [event]
    );

    if (!event && loading) {
        return <LoadingElement />;
    }

    if (!event) {
        return <NotFoundResult />;
    }

    return <EventDetailsInnerPage disabled={disabled || !hasUpdatePermission} event={event} />;
};

export default EventDetailsPage;
